export { default } from './ownerDocument';